export * from './contactdetail.component';


// WEBPACK FOOTER //
// /var/www/html/foodbot_stage/web/src/app/contactdetail/index.ts